/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_NameValue } from '../models/Volo_Abp_NameValue';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TimeZoneSettingsService {

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiSettingManagementTimezone(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/setting-management/timezone',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param timezone
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiSettingManagementTimezone(
        timezone?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/setting-management/timezone',
            query: {
                'timezone': timezone,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Volo_Abp_NameValue OK
     * @throws ApiError
     */
    public static getApiAwardApiSettingManagementTimezoneTimezones(): CancelablePromise<Array<Volo_Abp_NameValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/setting-management/timezone/timezones',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
